import React from "react";

const CargoOwnerDocsList = (props) => {
    const { documents } = props;
    if (documents.length === 0) {
        return <label className="col-form-label col-form-label-sm text-muted">Без документов</label>;
    }
    return (
        <ul>
            {documents.map((doc) => (
                <li key={doc.id}>
                    {doc.name} &times;{doc.count}
                </li>
            ))}
        </ul>
    );
};

export default CargoOwnerDocsList;
